var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImg262(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 34.5,
    r: 12.5,
    fill: "#ADA0F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_522_5818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5 15.5H15.5C14.837 15.5 14.2011 15.7634 13.7322 16.2322C13.2634 16.7011 13 17.337 13 18V38C13 38.663 13.2634 39.2989 13.7322 39.7678C14.2011 40.2366 14.837 40.5 15.5 40.5H30.5C31.163 40.5 31.7989 40.2366 32.2678 39.7678C32.7366 39.2989 33 38.663 33 38V23M25.5 15.5L33 23M25.5 15.5V23H33M28 29.25H18M28 34.25H18M20.5 24.25H18",
    stroke: "#151515",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.23239,
    cy: 16.8563,
    r: 1.5,
    transform: "rotate(-17 8.23239 16.8563)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.3808,
    cy: 9.44341,
    r: 1.5,
    transform: "rotate(-17 15.3808 9.44341)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.485 8.97936C8.78079 9.19466 8.03539 8.79832 7.8201 8.09412C7.7684 7.92503 7.65166 7.78341 7.49554 7.7004C7.33943 7.61739 7.15673 7.5998 6.98765 7.65149C6.81856 7.70319 6.67694 7.81994 6.59393 7.97605C6.51092 8.13216 6.49333 8.31486 6.54502 8.48395C6.77163 9.18066 6.38283 9.92779 5.68221 10.142L5.65978 10.1488C5.49069 10.2005 5.34907 10.3173 5.26606 10.4734C5.18305 10.6295 5.16546 10.8122 5.21716 10.9813C5.26885 11.1504 5.3856 11.292 5.54171 11.375C5.69783 11.458 5.88052 11.4756 6.04961 11.4239C6.75509 11.1947 7.51004 11.5961 7.71451 12.3092C7.7662 12.4782 7.88295 12.6199 8.03907 12.7029C8.19518 12.7859 8.37788 12.8035 8.54696 12.7518C8.71605 12.7001 8.85767 12.5833 8.94068 12.4272C9.02368 12.2711 9.04128 12.0884 8.98958 11.9193L8.98272 11.8969C8.76852 11.1963 9.17051 10.4562 9.87483 10.2544C10.0439 10.2027 10.1855 10.086 10.2685 9.92988C10.3516 9.77376 10.3691 9.59107 10.3174 9.42198C10.2658 9.2529 10.149 9.11127 9.99289 9.02827C9.83678 8.94526 9.65408 8.92767 9.485 8.97936Z",
    fill: "#263238"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_522_5818",
    x: 1.20888,
    y: 4.81147,
    width: 42.5822,
    height: 44.3752,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.395559
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.395559
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_522_5818"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_522_5818",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImg262);
export default __webpack_public_path__ + "static/media/icon-img-26-2.d9a1a2ba04d9cd38bb0efde99050a721.svg";
export { ForwardRef as ReactComponent };